import { useContext, createContext, useState, useEffect } from 'react'

import {
  modalDeleteGroupCommunityEventDispatch,
  modalDeleteGroupCommunityEventListener
} from '@space-shell/common/services/modal'

import type {
  GroupDeleteCommunityModalContextProps,
  GroupDeleteCommunityModalProviderProps
} from './types'

import GroupDeleteCommunityModal from '../..'

export type GroupDeleteCommunityModalEventsPayload = {
  action: 'open' | 'close'
  groupId: number
  groupName: string
}
const GroupDeleteCommunityModalContext = createContext<GroupDeleteCommunityModalContextProps>(
  {} as GroupDeleteCommunityModalContextProps
)

export const GroupDeleteCommunityModalProvider = ({
  children
}: GroupDeleteCommunityModalProviderProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [groupId, setgroupId] = useState<number>()

  useEffect(() => {
    modalDeleteGroupCommunityEventListener((event) => {
      const payload = (event as CustomEvent<GroupDeleteCommunityModalEventsPayload>).detail
      switch (payload.action) {
        case 'close':
          setIsOpen(false)
          break
        case 'open':
          setIsOpen(true)

          break
      }

      setgroupId(payload.groupId)
    })

    return () => setgroupId(undefined)
  }, [])

  const openDeleteGroupModal = (groupId: number) => {
    modalDeleteGroupCommunityEventDispatch({
      action: 'open',
      groupId
    })
  }

  const reset = () => {
    setIsOpen(false)
    setgroupId(0)
  }

  const closeDeleteGroupModal = () => {
    modalDeleteGroupCommunityEventDispatch({ action: 'close' })
    reset()
  }

  return (
    <GroupDeleteCommunityModalContext.Provider
      value={{
        openDeleteGroupModal,
        closeDeleteGroupModal,
        isOpen
      }}>
      <GroupDeleteCommunityModal
        groupId={groupId as number}
        isOpen={isOpen}
        closeModal={closeDeleteGroupModal}
      />
      {children}
    </GroupDeleteCommunityModalContext.Provider>
  )
}

export const useDeleteGroupCommunityModal = () => {
  const context = useContext(GroupDeleteCommunityModalContext)

  return context
}
